import { useAthleteFoodPreferenceContext } from "../../contexts/AthleteFoodPreferences";
import { useMealPlanFoodPreferenceContext } from "../../contexts/MealPlanFoodPreferences";
const hasHighlight = ({ foodOrRecipe, checkFunctions }) => {
    const mappedFoods = foodOrRecipe.__typename === "Recipe"
        ? foodOrRecipe.descendantFoods.flatMap(food => checkFunctions.map(fn => fn(food.id)))
        : checkFunctions.map(fn => fn(foodOrRecipe.id));
    const filteredFoods = mappedFoods.filter(({ value }) => value);
    const combinedReasons = [
        ...filteredFoods.reduce((acc, { reason }) => {
            return new Set([...acc, ...reason]);
        }, new Set()),
    ].sort();
    return {
        value: combinedReasons.length > 0,
        reason: combinedReasons,
    };
};
const hasHighlightGreen = ({ foodOrRecipe, isLikedFood, isPromotedFood }) => {
    return hasHighlight({
        foodOrRecipe,
        checkFunctions: [isLikedFood, isPromotedFood],
    });
};
const hasHighlightRed = ({ foodOrRecipe, isDislikedFood, isAvoidedFood }) => {
    return hasHighlight({
        foodOrRecipe,
        checkFunctions: [isDislikedFood, isAvoidedFood],
    });
};
export const useAthleteHighlightFromServingAmount = (foodOrRecipe) => {
    const { isLikedFood, isDislikedFood } = useAthleteFoodPreferenceContext();
    const { isAvoidedFood, isPromotedFood } = useMealPlanFoodPreferenceContext();
    const { value: isRed, reason: redReason } = hasHighlightRed({
        foodOrRecipe,
        isAvoidedFood,
        isDislikedFood,
    });
    if (isRed) {
        return {
            highlightType: "Red",
            reason: redReason,
        };
    }
    const { value: isGreen, reason: greenReason } = hasHighlightGreen({
        foodOrRecipe,
        isLikedFood,
        isPromotedFood,
    });
    return isGreen
        ? {
            highlightType: "Green",
            reason: greenReason,
        }
        : {
            highlightType: null,
            reason: [],
        };
};
export const useAthleteHighlightFromServingAmounts = (servingAmounts) => {
    const { isLikedFood, isDislikedFood } = useAthleteFoodPreferenceContext();
    const { isAvoidedFood, isPromotedFood } = useMealPlanFoodPreferenceContext();
    const isRedInit = {
        isRed: false,
        redReason: [],
    };
    const { isRed, redReason } = servingAmounts
        .map((servingAmount) => {
        const { foodOrRecipe } = servingAmount.serving;
        return hasHighlightRed({ foodOrRecipe, isAvoidedFood, isDislikedFood });
    })
        .reduce((acc, { value, reason }) => ({
        isRed: acc.isRed || value,
        redReason: [...new Set([...acc.redReason, ...reason])],
    }), isRedInit);
    if (isRed) {
        return {
            highlightType: "Red",
            reason: redReason,
        };
    }
    const isGreenInit = {
        isGreen: false,
        greenReason: [],
    };
    const { isGreen, greenReason } = servingAmounts
        .map(servingAmount => {
        const { foodOrRecipe } = servingAmount.serving;
        return hasHighlightGreen({ foodOrRecipe, isLikedFood, isPromotedFood });
    })
        .reduce((acc, { value, reason }) => ({
        isGreen: acc.isGreen || value,
        greenReason: [...new Set([...acc.greenReason, ...reason])],
    }), isGreenInit);
    return isGreen
        ? {
            highlightType: "Green",
            reason: greenReason,
        }
        : {
            highlightType: null,
            reason: [],
        };
};
export const useAthleteHighlightFromMenuItemPreview = (menuItem) => {
    const { servingAmounts } = menuItem;
    return useAthleteHighlightFromServingAmounts([...servingAmounts]);
};
export const useAvoidFoodGroups = () => {
    const { dislikedFoodGroups } = useAthleteFoodPreferenceContext();
    const { avoidedFoodGroups } = useMealPlanFoodPreferenceContext();
    return [...dislikedFoodGroups, ...avoidedFoodGroups];
};
//# sourceMappingURL=foods.js.map